import { createAction } from "typesafe-actions";
import { prefix } from "./constants.js";
const resetUpdateResult = createAction(`${prefix}/RESET`);
export {
  resetUpdateResult
};
//# sourceMappingURL=actions.js.map
